import React from 'react';
import { Link } from 'react-router-dom';
import { Crown, GraduationCap, PlayCircle } from 'lucide-react';
import { useLang, tx } from '../../i18n/LanguageContext';

export const LibraryCta = () => {
  const { lang } = useLang();
  const L = (ar, en) => tx(lang, ar, en);
  return (
    <section data-testid="library-cta" className="relative overflow-hidden mt-14 rounded-3xl bg-gradient-to-l from-blue-700 via-blue-600 to-indigo-700 px-6 py-8 sm:px-10 sm:py-9 shadow-xl shadow-blue-700/20">
      <div className="absolute inset-0 hero-grid-dark opacity-30 pointer-events-none" />
      <div className="relative flex flex-col lg:flex-row items-center gap-6 lg:gap-10">
        <span className="hidden sm:flex w-20 h-20 shrink-0 rounded-3xl bg-white/15 border border-white/25 backdrop-blur items-center justify-center rotate-6">
          <PlayCircle className="w-10 h-10 text-white" />
        </span>
        <div className="flex-1 text-center lg:text-start">
          <h2 className="text-2xl sm:text-3xl font-black text-white mb-2">{L('اكتشف المزيد من المحتوى التعليمي', 'Discover more learning content')}</h2>
          <p className="text-blue-100 text-sm sm:text-base">{L('احصل على وصول كامل إلى جميع الفيديوهات والدورات والمشاريع التطبيقية.', 'Get full access to every video, course and hands-on project.')}</p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
          <Link to="/courses" data-testid="library-cta-courses" className="h-12 px-6 rounded-xl border-2 border-white/60 text-white font-bold inline-flex items-center justify-center gap-2 hover:bg-white/10 transition-colors">
            <GraduationCap className="w-5 h-5" />{L('تصفح الكورسات', 'Browse courses')}
          </Link>
          <Link to="/subscription" data-testid="library-cta-subscribe" className="btn-subscribe h-12 px-7">
            <Crown className="w-5 h-5" />{L('اشترك الآن', 'Subscribe now')}
          </Link>
        </div>
      </div>
    </section>
  );
};

export const ListHeading = ({ Icon, title, list, unit, testId }) => {
  const { lang } = useLang();
  return (
    <div id={testId.replace('-count', '-list-top')} className="flex items-end justify-between gap-4 mb-5">
      <h2 className="flex items-center gap-2.5 text-xl sm:text-2xl font-black text-slate-900"><Icon className="w-7 h-7 text-blue-600" />{title}</h2>
      <span data-testid={testId} className="text-slate-500 text-sm whitespace-nowrap">
        {tx(lang, `عرض ${list.from} – ${list.to} من ${list.filtered.length} ${unit.ar}`, `Showing ${list.from}–${list.to} of ${list.filtered.length} ${unit.en}`)}
      </span>
    </div>
  );
};
